// extracted by mini-css-extract-plugin
export default {"pageContainer":"index_pageContainer__cGbiG","leftSection":"index_leftSection__PPXTH","rightSection":"index_rightSection__hKWba","explanationBox":"index_explanationBox__kEkmb"};